import { render, staticRenderFns } from "./ProviderRatingCarousel.vue?vue&type=template&id=e82e9fc6&scoped=true"
import script from "./ProviderRatingCarousel.vue?vue&type=script&lang=ts"
export * from "./ProviderRatingCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ProviderRatingCarousel.vue?vue&type=style&index=0&id=e82e9fc6&prod&lang=scss"
import style1 from "./ProviderRatingCarousel.vue?vue&type=style&index=1&id=e82e9fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82e9fc6",
  null
  
)

export default component.exports